module.exports = __webpack_public_path__ + "static/media/foot-width.1fcc5e87.svg";